<template>
  <div class="complete">
    <div class="box">
      <div class="title">Session has ended!</div>
      <div class="subtitle">
        Well done! You've successfully showed up once again to live your best
        life.
      </div>
      <div class="success-badge">
        <IconBase
          icon-name="success"
          iconColor="#444"
          viewBox="0 0 512.001 512.001"
          width="100%"
          height="100%"
          strokeWidth="0px"
          ><IconSuccess
        /></IconBase>
      </div>
      <div class="subtext text-align-center">
        Click below to complete the session and join your partner for a quick
        chat about how your session went. You'll be unmuted if you were muted.
      </div>
      <div class="confirm noselect text-align-center" @click="toggleModal">Complete Session</div>
    </div>
  </div>
</template>

<script>
import IconBase from "../IconBase";
import IconSuccess from "../SVG/IconSuccess";

export default {
  name: "SessionComplete",
  components: {
    IconBase,
    IconSuccess,
  },
  methods: {
    toggleModal() {
      window.mixpanel.track("Complete Session");
      this.$emit("toggleModal");
    },
  },
};
</script>

<style scoped>
.complete {
  width: 765px;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.complete .box {
  width: 590px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 75px 20px;
  background-color: white;
  margin-bottom: 65px;
  margin-top: 25px;
  border-radius: 3px;
  padding-bottom: 60px;
}

.complete .box .title {
  font-size: 45px;
}

.complete .box .subtitle {
  font-size: 24px;
  width: 75%;
  white-space: normal;
  font-weight: 400;
  padding: 15px 0px 0px 0px;
  /* text-align: justify; */
  text-align: center;
  margin: 0px auto;
  margin-top: 5px;
  line-height: 28px;
}

.complete .box .subtext {
  white-space: normal;
  width: 75%;
  padding: 5px 0px;
  margin-top: 35px;
  line-height: 23px;
  font-size: 17px;
  box-sizing: border-box;
  font-weight: 600;
}

.complete .box .confirm {
  font-size: 31px;
  outline: none;
  background-color: #e5ffec;
  color: #275400;
  font-weight: 600;
  border: unset;
  padding: 12px 10px;
  width: 100%;
  border-radius: 3px;
  cursor: pointer;
  display: block;
  margin: 0 auto;
  margin-top: 14px;
  max-width: 275px;
  transition: 0.1s ease-in-out;
}

.complete .box .confirm:hover {
  background-color: #d2ffdd;
}

.complete .box .success-badge {
  height: 200px;
  width: 200px;
  padding: 20px 0px;
  padding-bottom: 5px;
}
</style>